import { forwardRef } from 'react';

import { Text as NbText } from 'native-base';

import { addWithConfig } from '../../utils';

import type { TextProps } from './types';

/** @deprecated nativebase component deprecated, use `<Typography />` instead */
export const Text = forwardRef((props: TextProps, ref) => (
  <NbText ref={ref} variant="copyOne" {...props} />
));

/** @deprecated nativebase component deprecated, use `<Typography />` instead */
export default addWithConfig(Text);
